"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _base64Arraybuffer = require("base64-arraybuffer");

var _buildSSML = _interopRequireDefault(require("./buildSSML"));

var _isSSML = _interopRequireDefault(require("./isSSML"));

var DEFAULT_LANGUAGE = 'en-US';
var DEFAULT_VOICE = 'Microsoft Server Speech Text to Speech Voice (en-US, JessaRUS)';
var EMPTY_MP3_BASE64 = 'SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU3LjU2LjEwMQAAAAAAAAAAAAAA//tAwAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU3LjY0AAAAAAAAAAAAAAAAJAUHAAAAAAAAAYYoRBqpAAAAAAD/+xDEAAPAAAGkAAAAIAAANIAAAARMQU1FMy45OS41VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7EMQpg8AAAaQAAAAgAAA0gAAABFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';
var SYNTHESIS_CUSTOM_VOICE_URL_TEMPLATE = 'https://{region}.voice.speech.microsoft.com/cognitiveservices/v1?deploymentId={deploymentId}';
var SYNTHESIS_URL_TEMPLATE = 'https://{region}.tts.speech.microsoft.com/cognitiveservices/v1';

function _default(_x) {
  return _ref2.apply(this, arguments);
}

function _ref2() {
  _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var deploymentId, fetchAuthorizationTokenCredentials, _ref$lang, lang, outputFormat, pitch, rate, text, _ref$voice, voice, volume, _ref3, authorizationToken, region, ssml, url, res;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            deploymentId = _ref.deploymentId, fetchAuthorizationTokenCredentials = _ref.fetchAuthorizationTokenCredentials, _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? DEFAULT_LANGUAGE : _ref$lang, outputFormat = _ref.outputFormat, pitch = _ref.pitch, rate = _ref.rate, text = _ref.text, _ref$voice = _ref.voice, voice = _ref$voice === void 0 ? DEFAULT_VOICE : _ref$voice, volume = _ref.volume;

            if (text) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", (0, _base64Arraybuffer.decode)(EMPTY_MP3_BASE64));

          case 3:
            _context.next = 5;
            return fetchAuthorizationTokenCredentials();

          case 5:
            _ref3 = _context.sent;
            authorizationToken = _ref3.authorizationToken;
            region = _ref3.region;
            ssml = (0, _isSSML.default)(text) ? text : (0, _buildSSML.default)({
              lang: lang,
              pitch: pitch,
              rate: rate,
              text: text,
              voice: voice,
              volume: volume
            }); // Although calling encodeURI on hostname does not actually works, it fails faster and safer.

            url = deploymentId ? SYNTHESIS_CUSTOM_VOICE_URL_TEMPLATE.replace(/\{region\}/, encodeURI(region)).replace(/\{deploymentId\}/, encodeURI(deploymentId)) : SYNTHESIS_URL_TEMPLATE.replace(/\{region\}/, encodeURI(region));
            _context.next = 12;
            return fetch(url, {
              headers: {
                Authorization: "Bearer ".concat(authorizationToken),
                'Content-Type': 'application/ssml+xml',
                'X-Microsoft-OutputFormat': outputFormat
              },
              method: 'POST',
              body: ssml
            });

          case 12:
            res = _context.sent;

            if (res.ok) {
              _context.next = 15;
              break;
            }

            throw new Error("Failed to syntheis speech, server returned ".concat(res.status));

          case 15:
            return _context.abrupt("return", res.arrayBuffer());

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ref2.apply(this, arguments);
}